<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.progress_evaluation'),
                        href: meta.links.index,
                    },
                    {
                        name: progressEvaluation.category_name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end" v-if="meta.can.edit">
            <AppButton element="InertiaLink" :href="meta.links.edit">
                {{ $t('messages.edit') }}
            </AppButton>
        </div>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.title')" for="category_name" />
                        <div class="mt-1">
                            {{ progressEvaluation.category_name }}
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.max_score')" for="max_score" />
                        <div class="mt-1">
                            {{ progressEvaluation.max_score }}
                        </div>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $t('messages.dates_information') }}
            </template>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.school_year')" for="school_year" />
                        <div class="mt-1">
                            {{ progressEvaluation.school_year }}
                        </div>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $t('messages.success_criteria') }}
            </template>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.passing_students_percent')" for="passing_students_percent" />
                        <div class="mt-1">{{ progressEvaluation.passing_students_percent }}%</div>
                    </div>
                </div>

                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.average_improvement')" for="average_improvement" />
                        <div class="mt-1">{{ progressEvaluation.average_improvement }}%</div>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>

        <TitleFieldsFormSection>
            <template v-slot:title>
                <div>
                    <FormLabel :value="$t('messages.comment')" for="comment" />
                </div>
                <p class="mt-1 text-sm leading-5 text-gray-500">
                    {{ $t('messages.information_only_visible_by_teachers') }}
                </p>
            </template>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div class="sm:col-span-6">
                    <div class="mt-1">
                        <div class="mt-1">
                            {{ progressEvaluation.comment }}
                        </div>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $t('messages.grade_activity') }}
            </template>

            <GroupSelector :grade-levels="gradeLevels" :user-grade-levels="meta.preferences.user_grade_levels">
                <template v-slot:default="{ filteredGradeLevels }">
                    <div
                        class="mb-2 flex gap-x-2 items-end"
                        v-for="gradeLevel in filteredGradeLevels"
                        :key="gradeLevel.id"
                    >
                        <div v-for="group in gradeLevel.groups" :key="group.id">
                            <AppButton
                                element="inertia-link"
                                :href="group.links.progress_evaluation_group_index"
                                :desired-action="group.count === 0"
                                class=""
                            >
                                {{ group.name }} <span v-if="group.count" class="ml-1">({{ group.count }})</span>
                            </AppButton>
                        </div>
                    </div>
                </template>
            </GroupSelector>
        </TitleFieldsFormSection>

        <div>
            <apexchart
                type="bar"
                height="350"
                :series="comparisonChartData.series"
                :options="comparisonChartData"
            ></apexchart>
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import GroupSelector from '@/components/GroupSelector.vue';

export default {
    components: {
        GroupSelector,
        TitleFieldsFormSection,
        FormLabel,
        AppButton,
        PanelPage,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'progressEvaluation', 'gradeLevels', 'comparisonChartData'],
    data() {
        return {};
    },
};
</script>
